import { FC } from 'react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import {
  AuthenticationProvider,
  AssociateSetupProvider,
  store,
} from '@vs-online-only-app/state';
import { NetworkConnectionStatusProvider } from '@vs-online-only-app/ui';
import { AppRouter } from '../components/AppRouter';
import BrowserNotifications from '../components/BrowserNotifications';

const queryClient = new QueryClient();
const Router =
  process.env.NX_PUBLIC_USE_HASH_ROUTER === 'true' ? HashRouter : BrowserRouter;

if (window.top === window) {
  const queryParams = new URLSearchParams(window.location.search);
  const disableRedirect = queryParams.get('disableRedirect') === '1';
  const apiGatewayEndpoint = process.env.NX_PUBLIC_API_GATEWAY_ENDPOINT;
  const isProd = apiGatewayEndpoint === 'https://api.chat.bambuser.com';
  const isEU = window.location.hostname.startsWith('eu.');
  if (!disableRedirect && isProd) {
    const redirectUrl = isEU
      ? 'https://lcx-eu.bambuser.com'
      : 'https://lcx.bambuser.com';
    window.location.href = redirectUrl;
  }
}

const App: FC = () => (
  <QueryClientProvider client={queryClient}>
    <NetworkConnectionStatusProvider>
      <Provider store={store}>
          <Router>
            <AuthenticationProvider>
              <AssociateSetupProvider>
                <BrowserNotifications>
                  <AppRouter />
                </BrowserNotifications>
              </AssociateSetupProvider>
            </AuthenticationProvider>
          </Router>
      </Provider>
    </NetworkConnectionStatusProvider>
  </QueryClientProvider>
);

export default App;
